import { makeStyles, Theme } from '@material-ui/core';

export const useSocialStyles = makeStyles<Theme>(theme => ({
  list: {
    display: 'flex',
    margin: theme.spacing(1),
    padding: theme.spacing(1, 2),
    listStyle: 'none',
    height: '28px',
    borderRadius: '4px',
    justifyContent: 'end',
  },
  item: {
    padding: theme.spacing(0, 1),
    display: 'flex',
    alignItems: 'center',
  },

  icon: {
    padding: 4,
    '& svg':{
      height:"28px",
      width:"28px",
    },
  },
}));
